import { HttpContextToken } from '@angular/common/http';

/**
 * Per-request opt-outs for the resilience interceptors.
 *
 * These exist so an individual call can override cross-cutting behaviour without
 * editing the 27 services that make HTTP calls. Attach them via the `context`
 * option, e.g.:
 *
 *   this.http.get(url, { context: new HttpContext().set(SKIP_RETRY, true) })
 */

/** Per-request timeout in ms. `null` means "use the TimeoutInterceptor default". */
export const TIMEOUT_MS = new HttpContextToken<number | null>(() => null);

/** Opt a request out of RetryInterceptor entirely, regardless of method or status. */
export const SKIP_RETRY = new HttpContextToken<boolean>(() => false);

/** Cache lifetime in ms for CacheInterceptor. `0` means "do not cache". */
export const CACHE_TTL_MS = new HttpContextToken<number>(() => 0);
